
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '@/utils/trackingScripts';

/**
 * Component to track route changes for analytics (Google Analytics only)
 * Place this in your App component to track all route changes
 */
export const RouteTracker = () => {
  const location = useLocation();
  
  useEffect(() => {
    // Update tracking when the route changes
    const currentPath = location.pathname + location.search;
    
    // Track page view in analytics platforms (GTM and Google Analytics)
    trackPageView(currentPath, document.title);
    
    // Log for debugging
    console.log('Route changed:', currentPath);
  }, [location]);
  
  // This component doesn't render anything
  return null;
};
